<script>
    import ImageResponsive from "@/components/ImageResponsive";

    export default {
        name: "ApplicationInfo",
        components: { ImageResponsive },
        props: {
            title: String,
            type: {
                type: String,
                default: "app",
            },
        },
    };
</script>

<template>
    <section
        class="application-info application__section"
        :class="{ [`application-info--${type}`]: type }"
    >
        <div class="application-info__text">
            <component
                :is="type === 'app' ? 'h1' : 'h2'"
                class="application-info__title page-title"
                v-html="title"
            ></component>
            <template v-if="type === 'app'">
                <ul class="application-info__list">
                    <li class="application-info__item">
                        Ставьте цели и получайте полезные советы
                    </li>
                    <li class="application-info__item">
                        Отслеживайте прогресс в журнале и на графиках
                    </li>
                    <li class="application-info__item">
                        Сохраняйте замеры тела и следите за тенденцией
                    </li>
                </ul>
                <div class="application-info__apps">
                    <a
                        href="https://apps.apple.com/ru/app/picooc/id1101575679"
                        target="_blank"
                    >
                        <img src="/static/picooc/tonometer/icons/app-store.svg" alt="" />
                    </a>
                    <a
                        href="https://play.google.com/store/apps/details?id=com.picooc.international"
                        target="_blank"
                    >
                        <img src="/static/picooc/tonometer/icons/google-play.svg" alt="" />
                    </a>
                </div>
            </template>
            <template v-else>
                <div class="application-info__apps application-info__apps--image">
                    <img src="/static/picooc/tonometer/icons/apple-health.svg" alt="" />
                    <img src="/static/picooc/tonometer/icons/google-fit.svg" alt="" />
                </div>
            </template>
        </div>
        <div class="application-info__media-wrapper">
            <div class="application-info__media">
                <image-responsive
                    :mobile="`/static/picooc/application/info/m-${type}@2.jpg`"
                    :desktop="`/static/picooc/application/info/d-${type}@1.jpg`"
                    :desktop-x2="`/static/picooc/application/info/d-${type}@2.jpg`"
                    :alt="title"
                ></image-responsive>
            </div>
        </div>
    </section>
</template>

<style lang="scss">
    .application-info {
        background-color: #f4fbff;
        background-size: cover;
        @include bp($bp-desktop-sm) {
            display: flex;
            justify-content: space-between;
        }
    }

    .application-info--app {
        background-image: url("/static/picooc/application/info-app-fill--m.svg");
        @include bp($bp-desktop-sm) {
            background-image: url("/static/picooc/application/info-app-fill--d.svg");
        }
    }
    .application-info--sync {
        background-image: url("/static/picooc/application/info-sync-fill--m.svg");
        @include bp($bp-desktop-sm) {
            background-image: url("/static/picooc/application/info-sync-fill--d.svg");
        }
    }

    .application-info__text {
        margin-bottom: 32px;
        @include bp($bp-desktop-sm) {
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            width: 50%;
            max-width: 520px;
            margin-bottom: 0;
            padding-right: 15px;
        }
    }

    .application-info__title {
        margin-bottom: 16px;
        @include bp($bp-desktop-sm) {
            margin-bottom: 24px;
            max-width: 400px;
        }
    }

    .application-info__list {
        margin-bottom: 16px;
        color: #353535;
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
        list-style: none;

        @include bp($bp-desktop-sm) {
            margin-bottom: 24px;
            color: #474747;
            font-size: 16px;
        }
    }

    .application-info__item {
        position: relative;
        padding-left: 15px;
        &::before {
            content: "";
            position: absolute;
            top: 8px;
            left: 0;
            width: 6px;
            height: 6px;
            background-color: var(--primary--dark);
            border-radius: 50%;
        }
    }

    .application-info__media-wrapper {
        position: relative;
        @include bp($bp-desktop-sm) {
            flex-grow: 1;
            flex-shrink: 0;
            width: 50%;
            max-width: 630px;
        }
    }

    .application-info__media {
        background-color: transparent;
        border-radius: 20px;
        img {
            display: block;
            max-width: 100%;
            width: 100%;
            border-radius: 20px;
        }
    }

    .application-info__apps {
        display: flex;
        justify-content: center;
        a {
            max-width: 130px;
            overflow: hidden;
            &:first-child {
                margin-right: 16px;
            }
            @include bp($bp-desktop-md) {
                max-width: 150px;
            }
        }
        @include bp($bp-desktop-md) {
            justify-content: flex-start;
        }
    }

    .application-info__apps--image {
        justify-content: flex-start;
        img {
            width: 72px;
            height: 72px;
            &:first-child {
                margin-right: 15px;
            }
        }
        @include bp($bp-desktop-md) {
            margin-top: auto;
            img {
                width: 100px;
                height: 100px;
                &:first-child {
                    margin-right: 30px;
                }
            }
        }
    }
</style>
